var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("アカウント")])])],1),_c('MenuButtonList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }